import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Sidebar from './Sidebar';
import './Layout.css';

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="app-layout">
      {/* 사이드바 */}
      <div className="app-sidebar">
        <Sidebar />
      </div>

      {/* 메인 콘텐츠 */}
      <div className="app-main">
        {/* 헤더 */}
        <header className="app-header">
          <div className="layout__header-left">
            <h1 className="layout__page-title">오팀장 대시보드</h1>
          </div>

          <div className="layout__header-right">
            {user && (
              <div className="layout__user">
                <div className="layout__user-avatar">
                  {user.name.slice(0, 1)}
                </div>
                <span className="layout__user-name">{user.name}</span>
              </div>
            )}
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => void handleLogout()}
            >
              로그아웃
            </button>
          </div>
        </header>

        {/* 페이지 콘텐츠 */}
        <main className="app-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
